import React from 'react'

const CircleArrowIcon = (props) => {
	return(
		<svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43"><defs><filter id="a" x="0" y="0" width="43" height="43" filterUnits="userSpaceOnUse"><feOffset/><feGaussianBlur stdDeviation="2" result="blur"/><feFlood flood-opacity=".161"/><feComposite operator="in" in2="blur"/><feComposite in="SourceGraphic"/></filter></defs><g><circle cx="15.5" cy="15.5" r="15.5" transform="translate(6 6)" fill="#938888" filter="url(#a)"/><path d="M20.37 17.966l4.476 3.891-4.476 3.89" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" fill="none"/></g></svg>
	)
}

export default CircleArrowIcon